export default {
    order: state =>  state.order.data,
    orders: state =>  state.orders.data,
    orderDetail: state =>  state.orderDetail.data,
    stripeClientSecret: state =>  state.stripe.data.client_secret,
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/order/getters.js
// module id = null
// module chunks = 